import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useEventCountdown } from '../../hooks/use-countdown'

export const Timer = ({ finishAt }) => {
  const { t } = useTranslation()

  const { secondsRemaining } = useEventCountdown(finishAt)

  // 3. En cada render, convertimos los segundos restantes (count) a D/H/M/S.
  const secondsToTime = (totalSeconds) => {
    const days = Math.floor(totalSeconds / (60 * 60 * 24))
    const hours = Math.floor((totalSeconds % (60 * 60 * 24)) / (60 * 60))
    const minutes = Math.floor((totalSeconds % (60 * 60)) / 60)
    const seconds = Math.floor(totalSeconds % 60)
    return { days, hours, minutes, seconds }
  }

  const timeLeft = secondsToTime(secondsRemaining)

  // La lógica de renderizado ahora se basa en el `count` total de segundos.
  const lessThanADay = secondsRemaining < 86400 // 86400 segundos en un día

  return (
    <Container data-test="timer-container">
      {!lessThanADay && (
        <TimerComponent data-test="timer-component-days">
          <TimerPointerNumber data-test="hours">
            {String(timeLeft.days).padStart(2, '0')}
          </TimerPointerNumber>
          <TimePointerText data-test="timers-days">
            {t('homePage.countdownTimerDays').toUpperCase()}
          </TimePointerText>
        </TimerComponent>
      )}
      <TimerComponent data-test="timer-component-hours">
        <TimerPointerNumber data-test="hours">
          {String(timeLeft.hours).padStart(2, '0')}
        </TimerPointerNumber>
        <TimePointerText data-test="timers-hours">
          {t('homePage.countdownTimerHours').toUpperCase()}
        </TimePointerText>
      </TimerComponent>
      <TimerComponent data-test="timer-component-minutes">
        <TimerPointerNumber data-test="minutes">
          {String(timeLeft.minutes).padStart(2, '0')}
        </TimerPointerNumber>
        <TimePointerText data-test="timers-minutes">
          {t('homePage.countdownTimerMinutes').toUpperCase()}
        </TimePointerText>
      </TimerComponent>
      {lessThanADay && (
        <TimerComponent data-test="timer-components-seconds">
          <TimerPointerNumber data-test="seconds">
            {String(timeLeft.seconds).padStart(2, '0')}
          </TimerPointerNumber>
          <TimePointerText data-test="timers-seconds">
            {t('homePage.countdownTimerSeconds').toUpperCase()}
          </TimePointerText>
        </TimerComponent>
      )}
    </Container>
  )
}

const Container = styled.div`
  width: 100%;
  height: clamp(64px, 18vmin, 100px);
  font-size: 30px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: clamp(3px, 1.2vmin, 5px);
  text-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
`

const TimerComponent = styled.div`
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: clamp(12px, 5vmin, 20px);
  align-items: center;
  justify-content: center;
  min-width: clamp(56px, 22vmin, 5rem);
  min-height: clamp(56px, 22vmin, 5rem);
  line-height: initial;
`

const TimerPointerNumber = styled.span`
  font-family: 'Montserrat';
  font-weight: 600;
  font-size: clamp(22px, 9vmin, 35px);
  color: #50555c;
`
const TimePointerText = styled.span`
  font-family: 'Montserrat';
  font-weight: 700;
  font-size: clamp(7.5px, 2.8vmin, 10.5px);
  color: #50555c;
`
Timer.propTypes = {
  finishAt: PropTypes.number.isRequired,
}
